import * as React from 'react';

import { Granularity } from 'bloggers-backend/lib/bloggers/domain';
import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';
import { useFollowUpReport } from '../hooks/useFollowUpReport';
import { ReportControls } from './ReportControls';
import { ReportPeriodsView } from './ReportPeriodsView';

export function FollowUpReportPage() {
  const [granularity, setGranularity] = React.useState<Granularity>('month');
  const [dateRange, setDateRange] = React.useState<DateRange<Dayjs>>([
    dayjs().subtract(12, 'month'), dayjs()
  ]);

  const [startDate, endDate] = dateRange;
  const { data, isLoading, error } = useFollowUpReport(
    {
      granularity,
      startDate: startDate?.format('YYYY-MM-DD') ?? '',
      endDate: endDate?.format('YYYY-MM-DD') ?? '',
    },
    Boolean(startDate?.isValid() && endDate?.isValid())
  );

  return (
    <>
      <ReportControls
        granularity={granularity}
        onGranularityChange={setGranularity}
        dateRange={dateRange}
        onDateRangeChange={setDateRange}
      />
      <ReportPeriodsView
        users={data?.users}
        periods={data?.periods}
        isLoading={isLoading}
        error={error}
        chartTitle={`Follow-ups (${granularity})`}
        chartTestId="follow-up-report-chart"
      />
    </>
  );
}
